<template>
  <v-app>
    <BanjinoAgeGate />

    <BanjinoHeader />

    <v-main>
      <router-view v-slot="{ Component, route }">
        <transition name="page" mode="out-in">
          <component :is="Component" :key="route.fullPath" />
        </transition>
      </router-view>
    </v-main>

    <BanjinoFooter />

    <!-- Global snackbar — we don't show it by default; the snackbar composable can opt in -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      location="bottom right"
      rounded="lg"
    >
      {{ snackbar.message }}
      <template #actions>
        <v-btn variant="text" color="white" @click="snackbar.show = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>
import BanjinoAgeGate from '@/components/banjino/BanjinoAgeGate.vue'
import BanjinoHeader from '@/components/banjino/BanjinoHeader.vue'
import BanjinoFooter from '@/components/banjino/BanjinoFooter.vue'
import { useSnackbar } from '@/composables/useSnackbar'

const { snackbar } = useSnackbar()
</script>

<style>
/* Page transitions */
.page-enter-active,
.page-leave-active {
  transition: opacity 200ms ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}

/* Vuetify global resets */
.v-application {
  background: #FFFCF5;
}
.v-main {
  padding: 0 !important;
}
.v-btn { text-transform: none; }

/* Improve focus visibility globally for keyboard users */
*:focus-visible {
  outline: 3px solid rgba(235, 102, 31, 0.4);
  outline-offset: 2px;
}
</style>
